function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React, { Component } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { H, P, reset, buttonReset, FormGroup, Label, Hint, Textarea, Input, Modal, Button as Button$1, Select, Tabs, theme } from '@raketa-cms/raketa-mir';
export { FormGroup, Label, theme } from '@raketa-cms/raketa-mir';
import { ReactSortable } from 'react-sortablejs';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var add = function add(items, item) {
  return [].concat(items, [item]);
};

var removeByIndex = function removeByIndex(items, idx) {
  return [].concat(items.slice(0, idx), items.slice(idx + 1));
};

var removeById = function removeById(items, id, idField) {
  if (idField === void 0) {
    idField = 'id';
  }

  return removeByIndex(items, items.findIndex(function (current) {
    return current[idField] === id;
  }));
};

var updateFieldByIndex = function updateFieldByIndex(items, field, value, idx) {
  var _Object$assign;

  return [].concat(items.slice(0, idx), [Object.assign({}, items[idx], (_Object$assign = {}, _Object$assign[field] = value, _Object$assign))], items.slice(idx + 1));
};

var updateFieldById = function updateFieldById(items, field, value, id, idField) {
  if (idField === void 0) {
    idField = 'id';
  }

  return updateFieldByIndex(items, field, value, items.findIndex(function (current) {
    return current[idField] === id;
  }));
};

var randomId = function randomId() {
  return Math.floor(Math.random() * (999 - 100 + 1)) + 100;
};

var randomString = function randomString(length) {
  return Math.random().toString(36).substring(length);
};

var HostContext = React.createContext({});
var LibraryContext = React.createContext({});

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  z-index: 9;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var icons = {
  iconMove: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5tb3ZlPC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9Im1vdmUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+ICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIiBpZD0iU2hhcGUiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cG9seWxpbmUgcG9pbnRzPSIzIDcgMCAxMCAzIDEzIj48L3BvbHlsaW5lPiAgICAgICAgICAgIDxwb2x5bGluZSBwb2ludHM9IjcgMyAxMCAwIDEzIDMiPjwvcG9seWxpbmU+ICAgICAgICAgICAgPHBvbHlsaW5lIHBvaW50cz0iMTMgMTcgMTAgMjAgNyAxNyI+PC9wb2x5bGluZT4gICAgICAgICAgICA8cG9seWxpbmUgcG9pbnRzPSIxNyA3IDIwIDEwIDE3IDEzIj48L3BvbHlsaW5lPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDEwIEwyMCwxMCI+PC9wYXRoPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMCwwIEwxMCwyMCI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+',
  iconEdit: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5lZGl0LTI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iZWRpdC0yIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSIgaWQ9IlNoYXBlIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+ICAgICAgICAgICAgPHBvbHlnb24gcG9pbnRzPSIxMyAwIDE4IDUgNSAxOCAwIDE4IDAgMTMiPjwvcG9seWdvbj4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==',
  iconDelete: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT50cmFzaDwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJ0cmFzaCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMDAwMDAwLCAxLjAwMDAwMCkiIGlkPSJTaGFwZSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiPiAgICAgICAgICAgIDxwb2x5bGluZSBwb2ludHM9IjAgNCAyIDQgMTggNCI+PC9wb2x5bGluZT4gICAgICAgICAgICA8cGF0aCBkPSJNMTYsNCBMMTYsMTggQzE2LDE5LjEwNDU2OTUgMTUuMTA0NTY5NSwyMCAxNCwyMCBMNCwyMCBDMi44OTU0MzA1LDIwIDIsMTkuMTA0NTY5NSAyLDE4IEwyLDQgTTUsNCBMNSwyIEM1LDAuODk1NDMwNSA1Ljg5NTQzMDUsMCA3LDAgTDExLDAgQzEyLjEwNDU2OTUsMCAxMywwLjg5NTQzMDUgMTMsMiBMMTMsNCI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+',
  iconCopy: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItY29weSI+PHJlY3QgeD0iOSIgeT0iOSIgd2lkdGg9IjEzIiBoZWlnaHQ9IjEzIiByeD0iMiIgcnk9IjIiPjwvcmVjdD48cGF0aCBkPSJNNSAxNUg0YTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDlhMiAyIDAgMCAxIDIgMnYxIj48L3BhdGg+PC9zdmc+'
};
var colors = {
  primary: 'rgb(0,102,221)',
  secondary: '#000',
  danger: '#d00',
  neutral: '#fff'
};

var IconButton = function IconButton(props) {
  return /*#__PURE__*/React.createElement("div", _extends({
    type: "button",
    style: {
      display: 'inline-block',
      width: '32px',
      height: '32px',
      marginRight: '4px',
      marginLeft: props.type === 'neutral' ? '32px' : 0,
      appearance: 'none',
      outline: '0',
      border: '0',
      borderRadius: '3px',
      background: 'transparent',
      backgroundColor: colors[props.type] || '#000',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '50%',
      backgroundImage: "url(" + icons[props.icon] + ")",
      cursor: 'pointer'
    }
  }, props));
};

var AdminWidgetWrapper = styled.div(_templateObject(), function (props) {
  return "\n    &:hover {\n      position: relative;\n      box-shadow: inset 0 0 0 1px " + props.theme.colors.gray + ";\n\n      & > div[data-toolbar] { display: flex; }\n    }\n  ";
});
var AdminWidgetToolbar = styled.div(_templateObject2(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
});

var AdminWidget = function AdminWidget(_ref) {
  var library = _ref.library,
      identifier = _ref.identifier,
      widget = _ref.widget,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete;
  var currentWidget = library[widget.component];

  var handleDeleteWidget = function handleDeleteWidget() {
    if (!confirm('Are you sure?')) return;
    onDelete(widget.widgetId);
  };

  var handleCopyWidget = function handleCopyWidget() {
    var storedWidget = JSON.stringify({
      widgetName: widget.component,
      widget: widget
    });
    window.localStorage.setItem("clipboard\u2013" + identifier, storedWidget);
  };

  return /*#__PURE__*/React.createElement(AdminWidgetWrapper, null, /*#__PURE__*/React.createElement(AdminWidgetToolbar, {
    "data-toolbar": true
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconMove",
    "data-drag": true
  }), /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconEdit",
    type: "primary",
    onClick: function onClick() {
      return onEdit(widget);
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconDelete",
    type: "danger",
    onClick: function onClick() {
      return handleDeleteWidget();
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconCopy",
    type: "neutral",
    onClick: handleCopyWidget
  })), React.createElement(currentWidget, widget.settings));
};

AdminWidget.defaultProps = {
  containerSettings: {}
};

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBoundary, _Component);

  function ErrorBoundary(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      hasError: true
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    console.error(error, info);
  };

  _proto.render = function render() {
    if (this.state.hasError) return null;
    return this.props.children;
  };

  return ErrorBoundary;
}(Component);

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var EmptyCanvas = styled.div(_templateObject$1());
var Canvas = React.memo(function (_ref) {
  var widgets = _ref.widgets,
      onReorder = _ref.onReorder,
      onEdit = _ref.onEdit,
      onRemove = _ref.onRemove,
      identifier = _ref.identifier;
  var library = React.useContext(LibraryContext);

  if (widgets.length === 0) {
    return /*#__PURE__*/React.createElement(EmptyCanvas, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H, {
      size: "xxlarge"
    }, "It's always good to start with a clean slate."), /*#__PURE__*/React.createElement(P, null, "Use the sidebar to add content.")));
  }

  return /*#__PURE__*/React.createElement(ReactSortable, {
    list: widgets,
    setList: onReorder,
    handle: "[data-drag]",
    direction: "horizontal",
    dragoverBubble: true
  }, widgets.map(function (widget) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      key: widget.widgetId
    }, /*#__PURE__*/React.createElement(AdminWidget, {
      library: library,
      identifier: identifier,
      widget: widget,
      onEdit: onEdit,
      onDelete: onRemove
    }));
  }));
}, function (props, nextProps) {
  var themesAreEqual = JSON.stringify(props.themes) === JSON.stringify(nextProps.themes);
  var spacingsAreEqual = JSON.stringify(props.spacings) === JSON.stringify(nextProps.spacings);
  var widgetsAreEqual = JSON.stringify(props.widgets) === JSON.stringify(nextProps.widgets);
  return themesAreEqual && spacingsAreEqual && widgetsAreEqual;
});

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: ", ";\n  margin-bottom: ", ";\n\n  input:not([type]) {\n    position: absolute;\n    top: 0;\n    right: ", ";\n    left: ", ";\n    bottom: 0;\n    width: 125%;\n    padding-left: ", ";\n    padding-right: ", ";\n    font-size: ", ";\n    border: 0 !important;\n    border-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  display: block;\n  width: 100%;\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n  font-size: ", ";\n  font-weight: 300;\n  text-align: left;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    padding-left: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: none;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 64px;\n  width: 300px;\n  padding: ", ";\n  background-color: rgba(0, 0, 0, 0.9);\n  color: ", ";\n  backdrop-filter: blur(8px);\n  overflow-y: auto;\n  z-index: 11;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  display: block;\n  font-size: ", ";\n  color: ", ";\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: ", ";\n  ", "\n  width: 64px;\n  height: 64px;\n  border-bottom: 1px solid ", ";\n  z-index: 12;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    opacity: 0.9;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  z-index: 10;\n\n  &:hover > * {\n    display: block;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 64px;\n  background-color: ", ";\n  border-right: 1px solid ", ";\n  z-index: 10;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var SideNav = styled.div(_templateObject$2(), reset, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.darkerGray;
});
var NavItem = styled.div(_templateObject2$1(), function (props) {
  return props.bottom ? "\n    position: absolute;\n    bottom: 0;\n    border-top: 1px solid " + props.theme.colors.darkerGray + ";\n  " : '';
});
var NavButton = styled.button(_templateObject3(), reset, buttonReset, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.active ? props.theme.colors.darkerGray : props.success ? props.theme.colors.success : 'transparent';
}, function (props) {
  return props.icon ? "background-image: url(\"" + props.icon + "\");" : '';
}, function (props) {
  return props.theme.colors.darkerGray;
}, function (props) {
  return props.success ? props.theme.colors.success : props.theme.colors.darkerGray;
});
var NavPanel = styled.div(_templateObject4(), reset, function (props) {
  return "calc(" + props.theme.font.base + " * 2)";
}, function (props) {
  return props.theme.colors.white;
});
var NavSectionMenu = styled.div(_templateObject5());
var NavSectionMenuItem = styled.button(_templateObject6(), reset, buttonReset, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.darkerGray;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});
var SideNavSearchWrapper = styled.div(_templateObject7(), function (props) {
  return "calc(" + props.theme.font.base + " * 3.125)";
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return "calc(" + props.theme.font.base + " * -2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " * -2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " * 2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " * 2)";
}, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.white;
});

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: relative;\n  background-color: transparent;\n  width: 100%;\n  padding: 0;\n  margin-bottom: ", ";\n  font-size: ", ";\n  color: #999;\n  text-align: left;\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var SidebarItem = styled.button(_templateObject$3(), reset, buttonReset, function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.white;
});

var TextField = function TextField(_ref) {
  var label = _ref.label,
      hint = _ref.hint,
      multiline = _ref.multiline,
      error = _ref.error,
      _onChange = _ref.onChange,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "hint", "multiline", "error", "onChange"]);

  var id = randomString();
  var Component = multiline ? Textarea : Input;
  return /*#__PURE__*/React.createElement(FormGroup, null, label ? /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    error: error
  }, label) : '', /*#__PURE__*/React.createElement(Component, _extends({
    id: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, rest)), hint ? /*#__PURE__*/React.createElement(Hint, null, hint) : '');
};

var TextInput = function TextInput(props) {
  return /*#__PURE__*/React.createElement(TextField, props);
};

TextInput.defaultProps = {
  value: '',
  placeholder: ''
};

var sortByTitle = function sortByTitle(a, b) {
  var nameA = a.widgetTitle.toUpperCase();
  var nameB = b.widgetTitle.toUpperCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

var AdminSidebar = function AdminSidebar(_ref) {
  var identifier = _ref.identifier,
      dirty = _ref.dirty,
      buttons = _ref.buttons,
      onAddWidget = _ref.onAddWidget,
      onReorderDialog = _ref.onReorderDialog,
      onPasteWidget = _ref.onPasteWidget,
      onSave = _ref.onSave,
      onExit = _ref.onExit;
  var library = React.useContext(LibraryContext);

  var _React$useState = React.useState(''),
      q = _React$useState[0],
      setQ = _React$useState[1];

  var handlePasteWidget = function handlePasteWidget() {
    window.localStorage.getItem("clipboard\u2013" + identifier);
    onPasteWidget();
  };

  var renderWidgets = function renderWidgets() {
    var widgets = Object.keys(library).filter(function (widgetName) {
      return !library[widgetName].deprecated;
    }).filter(function (widgetName) {
      return library[widgetName].title.toLowerCase().indexOf(q.toLowerCase()) !== -1;
    });
    var widgetsCategories = widgets.map(function (widgetName) {
      return library[widgetName].category;
    }).filter(function (c, idx, self) {
      return self.indexOf(c) === idx;
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SideNavSearchWrapper, null, /*#__PURE__*/React.createElement(TextInput, {
      value: q,
      onChange: setQ,
      placeholder: "Search..."
    })), widgetsCategories.map(function (categoryName, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        style: {
          marginBottom: '25px'
        }
      }, /*#__PURE__*/React.createElement(H, {
        size: "medium",
        style: {
          color: '#fff'
        }
      }, categoryName), widgets.filter(function (widgetName) {
        return library[widgetName].category === categoryName;
      }).map(function (widgetName) {
        return {
          widgetName: widgetName,
          widgetTitle: library[widgetName].title
        };
      }).sort(sortByTitle).map(function (item, idx) {
        return /*#__PURE__*/React.createElement(SidebarItem, {
          key: idx,
          onClick: function onClick() {
            return onAddWidget(item.widgetName);
          }
        }, item.widgetTitle);
      }));
    }));
  };

  return /*#__PURE__*/React.createElement(SideNav, null, /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    icon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5wbHVzLWNpcmNsZTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJwbHVzLWNpcmNsZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiPjwvY2lyY2xlPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMCw2IEwxMCwxNCIgaWQ9IlNoYXBlIj48L3BhdGg+ICAgICAgICAgICAgPHBhdGggZD0iTTYsMTAgTDE0LDEwIiBpZD0iU2hhcGUiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement(NavPanel, null, /*#__PURE__*/React.createElement(H, {
    size: "large",
    style: {
      color: '#fff'
    }
  }, "Library"), renderWidgets())), /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    icon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5saXN0PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9Imxpc3QiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wMDAwMDAsIDUuMDAwMDAwKSIgaWQ9IlNoYXBlIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cGF0aCBkPSJNMCwwIEwxMywwIj48L3BhdGg+ICAgICAgICAgICAgPHBhdGggZD0iTTAsNiBMMTMsNiI+PC9wYXRoPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDEyIEwxMywxMiI+PC9wYXRoPiAgICAgICAgPC9nPiAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC0yIiBmaWxsPSIjRkZGRkZGIiBjeD0iMyIgY3k9IjUiIHI9IjEiPjwvY2lyY2xlPiAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC0yIiBmaWxsPSIjRkZGRkZGIiBjeD0iMyIgY3k9IjE3IiByPSIxIj48L2NpcmNsZT4gICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwtMiIgZmlsbD0iI0ZGRkZGRiIgY3g9IjMiIGN5PSIxMSIgcj0iMSI+PC9jaXJjbGU+ICAgIDwvZz48L3N2Zz4=",
    onClick: onReorderDialog
  })), /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    icon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5jaGVjazwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJjaGVjayIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuMDAwMDAwLCA2LjAwMDAwMCkiIGlkPSJTaGFwZSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiPiAgICAgICAgICAgIDxwb2x5bGluZSBwb2ludHM9IjE2IDAgNSAxMSAwIDYiPjwvcG9seWxpbmU+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=",
    success: dirty,
    onClick: onSave
  })), /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    icon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAxOCAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5jbGlwYm9hcmQ8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIGlkPSJjbGlwYm9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8ZyBpZD0iY2xpcGJvYXJkLXdoaXRlIj4gICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLDIgTDE0LDIgQzE1LjEwNDU2OTUsMiAxNiwyLjg5NTQzMDUgMTYsNCBMMTYsMTggQzE2LDE5LjEwNDU2OTUgMTUuMTA0NTY5NSwyMCAxNCwyMCBMMiwyMCBDMC44OTU0MzA1LDIwIDAsMTkuMTA0NTY5NSAwLDE4IEwwLDQgQzAsMi44OTU0MzA1IDAuODk1NDMwNSwyIDIsMiBMNCwyIiBpZD0iUGF0aCI+PC9wYXRoPiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSI0IiB5PSIwIiB3aWR0aD0iOCIgaGVpZ2h0PSI0IiByeD0iMSI+PC9yZWN0PiAgICAgICAgICAgIDwvZz4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==",
    onClick: handlePasteWidget
  })), buttons && buttons.map(function (button) {
    return /*#__PURE__*/React.createElement(NavItem, {
      key: button.id
    }, /*#__PURE__*/React.createElement(NavButton, {
      id: button.id,
      className: button.className,
      onClick: function onClick() {
        return button.onClick();
      }
    }, button.label));
  }), /*#__PURE__*/React.createElement(NavItem, {
    bottom: true
  }, /*#__PURE__*/React.createElement(NavButton, {
    icon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5jaGV2cm9ucy1sZWZ0PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9ImNoZXZyb25zLWxlZnQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+ICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjAwMDAwMCwgNi4wMDAwMDApIiBpZD0iU2hhcGUiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cG9seWxpbmUgcG9pbnRzPSI1IDEwIDAgNSA1IDAiPjwvcG9seWxpbmU+ICAgICAgICAgICAgPHBvbHlsaW5lIHBvaW50cz0iMTIgMTAgNyA1IDEyIDAiPjwvcG9seWxpbmU+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=",
    onClick: onExit
  })));
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n  border-top: 2px solid ", ";\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: 75vh;\n  overflow-y: auto;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var ModalContent = styled.div(_templateObject$4());
var ModalFooter = styled.div(_templateObject2$2(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.lightGray;
});

var Dialog = function Dialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      title = _ref.title,
      children = _ref.children,
      primaryLabel = _ref.primaryLabel,
      _ref$secondaryLabel = _ref.secondaryLabel,
      secondaryLabel = _ref$secondaryLabel === void 0 ? 'Cancel' : _ref$secondaryLabel,
      onPrimary = _ref.onPrimary;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    title: title,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(ModalContent, null, children), (primaryLabel || secondaryLabel) && /*#__PURE__*/React.createElement(ModalFooter, null, primaryLabel && /*#__PURE__*/React.createElement(Button$1, {
    type: "button",
    variant: "primary",
    onClick: onPrimary
  }, primaryLabel), secondaryLabel && /*#__PURE__*/React.createElement(Button$1, {
    type: "button",
    variant: "secondary",
    onClick: onClose
  }, secondaryLabel)));
};

Dialog.defaultProps = {
  children: [],
  dialogSize: ''
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", ";\n  margin-bottom: ", ";\n  border: 1px solid ", ";\n  border-radius: 3px;\n  color: ", ";\n  cursor: move;\n\n  h6 {\n    margin-bottom: 0;\n    margin-left: ", ";\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var Handle = function Handle(props) {
  return /*#__PURE__*/React.createElement("img", _extends({}, props, {
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItbW9yZS12ZXJ0aWNhbCI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMSI+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSI1IiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGN4PSIxMiIgY3k9IjE5IiByPSIxIj48L2NpcmNsZT48L3N2Zz4="
  }));
};

var ReorderDialogItem = styled.div(_templateObject$5(), function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});

var cleanup = function cleanup(string) {
  return string.replace(/<[^>]*>?/gm, '');
};

var truncate = function truncate(str, num) {
  if (str.length <= num) return str;
  return str.slice(0, num) + '…';
};

var getWidgetTitle = function getWidgetTitle(library, widget) {
  var widgetComponent = library[widget.component];
  var widgetName = widgetComponent.title || widget.component;
  var widgetTitle = widgetComponent.primaryField ? truncate(cleanup(widget.settings[widgetComponent.primaryField]), 32) : '';
  return [widgetName, widgetTitle].filter(function (s) {
    return s !== '';
  }).join(': ');
};

var ReorderDialog = function ReorderDialog(_ref) {
  var widgets = _ref.widgets,
      onClose = _ref.onClose,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      onSelectWidget = _ref.onSelectWidget;
  var library = React.useContext(LibraryContext);
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    onClose: onClose,
    title: "Reorder",
    primaryLabel: "",
    secondaryLabel: "Close"
  }, /*#__PURE__*/React.createElement(P, null, "Drag and drop elements below to reorder the page layout."), /*#__PURE__*/React.createElement(ReactSortable, {
    list: widgets,
    setList: onChange,
    handle: "[data-drag]",
    direction: "horizontal",
    dragoverBubble: true
  }, widgets.map(function (widget) {
    return /*#__PURE__*/React.createElement("div", {
      key: widget.widgetId
    }, /*#__PURE__*/React.createElement(ReorderDialogItem, {
      "data-drag": true
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(Handle, {
      style: {
        display: 'inline-block',
        width: '16px',
        marginRight: '.5em'
      }
    }), /*#__PURE__*/React.createElement(H, {
      size: "base",
      style: {
        paddingBottom: 0,
        fontWeight: 500
      }
    }, getWidgetTitle(library, widget))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button$1, {
      type: "button",
      variant: "primary",
      onClick: function onClick() {
        onClose();
        onSelectWidget(widget);
      }
    }, "Edit"), /*#__PURE__*/React.createElement(Button$1, {
      type: "button",
      variant: "danger",
      onClick: function onClick() {
        if (!confirm('Are you sure?')) return;
        onDelete(widget.widgetId);
      }
    }, "\xD7"))));
  })));
};

ReorderDialog.defaultProps = {
  widgets: []
};

var TextArea = function TextArea(props) {
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    multiline: true
  }, props));
};

TextArea.defaultProps = {
  value: '',
  placeholder: ''
};

var RichText = function RichText() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "RichText is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-rte"), /*#__PURE__*/React.createElement("strong", null, "Update your imports"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "import {RichText} from '@raketa-cms/raketa-rte';")), /*#__PURE__*/React.createElement("strong", null, "Update usage in JSON adminFields"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "text: { type: 'custom', component: RichText },")));
};

var getOptions = function getOptions(options, placeholder) {
  var initialOptions = placeholder ? [{
    value: '',
    text: placeholder
  }] : [];
  var preparedOptions = options.map(function (o) {
    return {
      value: o[0],
      text: o[1]
    };
  });
  return [].concat(initialOptions, preparedOptions);
};

var SelectField = function SelectField(props) {
  var id = randomString();
  var label = props.label,
      hint = props.hint,
      options = props.options,
      placeholder = props.placeholder,
      _onChange = props.onChange;
  var inputProps = Object.assign({}, props);
  delete inputProps.label;
  delete inputProps.hint;
  delete inputProps.options;
  delete inputProps.placeholder;
  delete inputProps.onChange;
  return /*#__PURE__*/React.createElement(FormGroup, null, label ? /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    error: props.error
  }, label) : '', /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, inputProps), placeholder ? /*#__PURE__*/React.createElement("option", {
    key: "placeholder",
    value: null
  }, placeholder) : '', options.map(function (o) {
    return /*#__PURE__*/React.createElement("option", {
      key: o.value,
      value: o.value
    }, o.text);
  })), hint ? /*#__PURE__*/React.createElement(Hint, null, hint) : '');
};

var SelectMenu = function SelectMenu(_ref) {
  var label = _ref.label,
      options = _ref.options,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(SelectField, {
    label: label,
    options: getOptions(options, placeholder),
    value: value,
    onChange: onChange
  });
};

SelectMenu.defaultProps = {
  value: '',
  placeholder: 'Please select...'
};

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  margin-bottom: 0;\n\n  & + div {\n    margin-top: ", ";\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: ", ";\n  font-size: ", ";\n  text-transform: uppercase;\n  font-weight: bold;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n\n  & > div {\n    width: 33.33%;\n    padding-right: ", ";\n\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n\n  &:last-child {\n    & > div {\n      margin-bottom: 0;\n    }\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  margin-right: ", ";\n  background-size: 100% auto;\n  background-repeat: none;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItc2xpZGVycyI+PGxpbmUgeDE9IjQiIHkxPSIyMSIgeDI9IjQiIHkyPSIxNCI+PC9saW5lPjxsaW5lIHgxPSI0IiB5MT0iMTAiIHgyPSI0IiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjIxIiB4Mj0iMTIiIHkyPSIxMiI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjgiIHgyPSIxMiIgeTI9IjMiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIyMSIgeDI9IjIwIiB5Mj0iMTYiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIxMiIgeDI9IjIwIiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxIiB5MT0iMTQiIHgyPSI3IiB5Mj0iMTQiPjwvbGluZT48bGluZSB4MT0iOSIgeTE9IjgiIHgyPSIxNSIgeTI9IjgiPjwvbGluZT48bGluZSB4MT0iMTciIHkxPSIxNiIgeDI9IjIzIiB5Mj0iMTYiPjwvbGluZT48L3N2Zz4=);\n}"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var SettingsIcon = styled.span(_templateObject$6(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});
var ThreeColumns = styled.div(_templateObject2$3(), reset, function (props) {
  return props.theme.font.base;
});
var FormSectionTitle = styled.h6(_templateObject3$1(), reset, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.font.small;
});
var ButtonControl = styled.div(_templateObject4$1(), reset, function (props) {
  return props.theme.font.base;
});

var mergeSettings = function mergeSettings(settings, key, value) {
  var _Object$assign;

  return Object.assign({}, settings, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
};

var ButtonSettings = function ButtonSettings(_ref) {
  var label = _ref.label,
      value = _ref.value,
      _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(ButtonControl, null, /*#__PURE__*/React.createElement(FormSectionTitle, null, /*#__PURE__*/React.createElement(SettingsIcon, null), " ", label), /*#__PURE__*/React.createElement(ThreeColumns, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: value.label,
    onChange: function onChange(label) {
      return _onChange(mergeSettings(value, 'label', label));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Link",
    value: value.link,
    onChange: function onChange(link) {
      return _onChange(mergeSettings(value, 'link', link));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "ID",
    value: value.id,
    onChange: function onChange(id) {
      return _onChange(mergeSettings(value, 'id', id));
    }
  })), /*#__PURE__*/React.createElement(ThreeColumns, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Type",
    options: [['primary', 'Primary'], ['secondary', 'Secondary'], ['text', 'Text']],
    value: value.type,
    onChange: function onChange(type) {
      return _onChange(mergeSettings(value, 'type', type));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Target",
    options: [['_self', 'Self'], ['_blank', 'New Tab']],
    value: value.target,
    onChange: function onChange(target) {
      return _onChange(mergeSettings(value, 'target', target));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Follow Link",
    options: [['follow', 'Follow'], ['nofollow', 'No Follow']],
    value: value.rel,
    onChange: function onChange(rel) {
      return _onChange(mergeSettings(value, 'rel', rel));
    }
  })));
};

var DEFAULTS = {
  label: 'Button',
  link: '#',
  id: '',
  type: 'primary',
  target: '_self',
  rel: 'follow'
};
ButtonSettings.defaultProps = {
  label: 'Button',
  value: DEFAULTS
};
ButtonSettings.defaults = DEFAULTS;

var toUnderscore = function toUnderscore(string) {
  return string.replace(/([A-Z])/g, function ($1) {
    return "_" + $1.toLowerCase();
  });
};

var humanize = function humanize(string) {
  return toUnderscore(string).replace(/_/g, ' ');
};

var capitalize = function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

var ImagePicker = function ImagePicker() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "ImagePicker is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-image-input.", ' '), /*#__PURE__*/React.createElement("strong", null, "Update imports"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "import { ImagePicker } from '@raketa-cms/raketa-image-picker';")), /*#__PURE__*/React.createElement("strong", null, "Update JSON adminFields"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "image: { type: 'custom', component: ImagePicker },")));
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 32%;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var SegmentWrapper = styled.div(_templateObject$7());
var Segment = styled.div(_templateObject2$4());

var renderField = function renderField(field, value, onChange, opts) {
  var handleChange = function handleChange(newValue) {
    return onChange(field, newValue);
  };

  switch (opts.type) {
    case 'text':
      {
        return /*#__PURE__*/React.createElement(TextInput, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }

    case 'textarea':
      {
        return /*#__PURE__*/React.createElement(TextArea, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }

    case 'rich':
      {
        return /*#__PURE__*/React.createElement(RichText, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }

    case 'select':
      {
        return /*#__PURE__*/React.createElement(SelectMenu, _extends({
          key: "dialog-" + field,
          label: opts.label,
          options: opts.options,
          value: value,
          onChange: handleChange
        }, opts));
      }

    case 'image':
      {
        return /*#__PURE__*/React.createElement(ImagePicker, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }

    case 'button':
      {
        return /*#__PURE__*/React.createElement(ButtonSettings, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }

    case 'custom':
      {
        var Component = opts.component;
        return /*#__PURE__*/React.createElement(Component, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }

    default:
      {
        return /*#__PURE__*/React.createElement(TextInput, {
          key: "dialog-" + field,
          label: field,
          value: value,
          onChange: handleChange
        });
      }
  }
};

var renderAdminFields = function renderAdminFields(widget, settings, onChange) {
  return Object.keys(widget.adminFields).map(function (field) {
    var opts = Object.assign({
      label: capitalize(humanize(field))
    }, widget.adminFields[field]);
    return renderField(field, settings[field], onChange, opts);
  });
};

var SettingsDialog = function SettingsDialog(_ref) {
  var spacings = _ref.spacings,
      themes = _ref.themes,
      widget = _ref.widget,
      settings = _ref.settings,
      onSave = _ref.onSave,
      onClose = _ref.onClose;

  var _React$useState = React.useState(settings),
      localSettings = _React$useState[0],
      setLocalSettings = _React$useState[1];

  var handleChangeField = function handleChangeField(field, value) {
    var _extends2;

    setLocalSettings(_extends(_extends({}, localSettings), {}, (_extends2 = {}, _extends2[field] = value, _extends2)));
  };

  var handleUpdateLayoutSettings = function handleUpdateLayoutSettings(field, value) {
    var _extends3;

    handleChangeField('containerSettings', _extends(_extends({}, localSettings.containerSettings), {}, (_extends3 = {}, _extends3[field] = value, _extends3)));
  };

  var fields;

  if (_typeof(widget.adminFields) === 'object') {
    fields = renderAdminFields(widget, localSettings, handleChangeField);
  }

  if (typeof widget.adminFields === 'function') {
    var items = localSettings.list ? localSettings.list : [];
    fields = widget.adminFields(items, handleChangeField, localSettings);
  }

  var _localSettings$contai = localSettings.containerSettings,
      containerSettings = _localSettings$contai === void 0 ? {} : _localSettings$contai;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    title: widget.title,
    primaryLabel: "OK",
    width: "700px",
    onPrimary: function onPrimary() {
      return onSave(localSettings);
    },
    onClose: onClose,
    dialogSize: widget.dialogSize
  }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement("div", {
    title: "Content"
  }, fields), /*#__PURE__*/React.createElement("div", {
    title: "Settings"
  }, /*#__PURE__*/React.createElement(SegmentWrapper, null, /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Spacing",
    options: spacings,
    value: containerSettings.spacing || '',
    onChange: function onChange(newValue) {
      return handleUpdateLayoutSettings('spacing', newValue);
    }
  })), /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Theme",
    options: themes,
    value: containerSettings.theme || '',
    onChange: function onChange(newValue) {
      return handleUpdateLayoutSettings('theme', newValue);
    }
  })), /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Section ID",
    value: containerSettings.sectionID || '',
    onChange: function onChange(newValue) {
      return handleUpdateLayoutSettings('sectionID', newValue);
    }
  }))))));
};

var usePreventWindowUnload = function usePreventWindowUnload(preventDefault) {
  React.useEffect(function () {
    if (!preventDefault) return;

    var handleBeforeUnload = function handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return function () {
      return window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [preventDefault]);
};

var PageBuilder = function PageBuilder(_ref) {
  var initialPage = _ref.page,
      library = _ref.library,
      spacings = _ref.spacings,
      themes = _ref.themes,
      navigation = _ref.navigation,
      identifier = _ref.identifier,
      sidebarButtons = _ref.sidebarButtons,
      host = _ref.host,
      onChange = _ref.onChange,
      onSave = _ref.onSave,
      onExit = _ref.onExit;

  var _React$useState = React.useState(initialPage),
      page = _React$useState[0],
      setPage = _React$useState[1];

  var _React$useState2 = React.useState(false),
      dirty = _React$useState2[0],
      setDirty = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      selectedWidget = _React$useState3[0],
      setSelectedWidget = _React$useState3[1];

  var _React$useState4 = React.useState(false),
      reorderOpen = _React$useState4[0],
      setReorderOpen = _React$useState4[1];

  usePreventWindowUnload(dirty);
  var currentWidget = selectedWidget ? library[selectedWidget.component] : null;

  var factory = function factory(widgetName) {
    var widget = library[widgetName];
    return {
      widgetId: randomString(6),
      component: widgetName,
      settings: widget.defaults
    };
  };

  var handleAdd = function handleAdd(widgetName) {
    var widgets = add(page.widgets, factory(widgetName));

    var newPage = _extends(_extends({}, page), {}, {
      widgets: widgets
    });

    setPage(newPage);
    setDirty(true);
    notifyChange(newPage);
  };

  var handleUpdate = function handleUpdate(widget) {
    var widgets = updateFieldById(page.widgets, 'settings', widget.settings, widget.widgetId, 'widgetId');

    var newPage = _extends(_extends({}, page), {}, {
      widgets: widgets
    });

    setPage(newPage);
    notifyChange(newPage);
  };

  var handleRemove = function handleRemove(id) {
    var widgets = removeById(page.widgets, id, 'widgetId');

    var newPage = _extends(_extends({}, page), {}, {
      widgets: widgets
    });

    setPage(newPage);
    setDirty(true);
    notifyChange(newPage);
  };

  var handleReorder = function handleReorder(widgets) {
    if (page.widgets.map(function (w) {
      return w.widgetId;
    }).join() !== widgets.map(function (w) {
      return w.widgetId;
    }).join()) {
      var newPage = _extends(_extends({}, page), {}, {
        widgets: widgets
      });

      setPage(newPage);
      setDirty(true);
      notifyChange(newPage);
    }
  };

  var notifyChange = function notifyChange(page) {
    return onChange(page);
  };

  var handleSave = function handleSave() {
    onSave(page);
    setDirty(false);
  };

  var handlePasteWidget = function handlePasteWidget() {
    var clipboardWidget = JSON.parse(window.localStorage.getItem("clipboard\u2013" + identifier));
    if (!clipboardWidget) return alert('Nothing to paste, yet');
    var newWidget = {
      widgetId: randomString(6),
      component: clipboardWidget.widgetName,
      settings: clipboardWidget.widget.settings
    };
    console.log(newWidget);
    var widgets = add(page.widgets, newWidget);

    var newPage = _extends(_extends({}, page), {}, {
      widgets: widgets
    });

    setPage(newPage);
    setDirty(true);
    notifyChange(newPage);
  };

  var handleSaveWidget = function handleSaveWidget(settings) {
    handleUpdate(_extends(_extends({}, selectedWidget), {}, {
      settings: settings
    }));
    setDirty(true);
    setSelectedWidget(null);
  };

  var handleClose = function handleClose() {
    setSelectedWidget(null);
  };

  var widgets = page.widgets;
  var sortableWidgets = widgets.map(function (widget) {
    return _extends(_extends({}, widget), {}, {
      id: widget.widgetId,
      chosen: false,
      selected: false
    });
  });
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(HostContext.Provider, {
    value: {
      host: host
    }
  }, /*#__PURE__*/React.createElement(LibraryContext.Provider, {
    value: library
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: '64px'
    }
  }, reorderOpen && /*#__PURE__*/React.createElement(ReorderDialog, {
    widgets: sortableWidgets,
    onChange: handleReorder,
    onDelete: handleRemove,
    onSelectWidget: setSelectedWidget,
    onClose: function onClose() {
      return setReorderOpen(false);
    }
  }), /*#__PURE__*/React.createElement(AdminSidebar, {
    navigation: navigation,
    dirty: dirty,
    buttons: sidebarButtons,
    identifier: identifier,
    onSave: handleSave,
    onAddWidget: handleAdd,
    onReorderDialog: function onReorderDialog() {
      return setReorderOpen(true);
    },
    onExit: onExit,
    onPasteWidget: handlePasteWidget
  }), /*#__PURE__*/React.createElement(Canvas, {
    widgets: sortableWidgets,
    identifier: identifier,
    onReorder: handleReorder,
    onEdit: setSelectedWidget,
    onRemove: handleRemove
  }), selectedWidget && /*#__PURE__*/React.createElement(SettingsDialog, {
    spacings: spacings,
    themes: themes,
    widget: currentWidget,
    settings: selectedWidget.settings,
    onSave: handleSaveWidget,
    onClose: handleClose
  })))));
};

PageBuilder.defaultProps = {
  themes: [['none', 'None'], ['light', 'Light'], ['dark', 'Dark']],
  spacings: [['none', 'None'], ['both', 'Both'], ['top', 'Top'], ['bottom', 'Bottom']]
};

var ImageInput = function ImageInput() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "ImageInput is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-image-input.", ' '), /*#__PURE__*/React.createElement("strong", null, "Update imports"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "import { ImageInput } from '@raketa-cms/raketa-image-picker';")));
};

var Img = function Img(_ref) {
  var src = _ref.src,
      variant = _ref.variant,
      className = _ref.className,
      onLoad = _ref.onLoad,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? null : _ref$alt,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = _objectWithoutPropertiesLoose(_ref, ["src", "variant", "className", "onLoad", "alt", "title"]);

  if (!src) {
    console.warn("WARNING: Image with src null or undefined will not be rendered: " + variant + " " + (className || ''));
    return null;
  }

  var imgAlt = alt !== null ? alt : src.alt;
  var imgTitle = title !== null ? title : '';
  if (_typeof(src) === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + variant + " " + (className || ''));
  if (_typeof(src) === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return /*#__PURE__*/React.createElement("img", _extends({
    src: src.urls.original,
    alt: imgAlt !== null ? imgAlt : src.name,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  if (_typeof(src) === 'object' && 'name' in src) return /*#__PURE__*/React.createElement("img", _extends({
    src: src.urls[variant],
    alt: imgAlt !== null ? imgAlt : src.name,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  if (typeof src === 'string') return /*#__PURE__*/React.createElement("img", _extends({
    src: src,
    alt: src,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  return null;
};

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-left: 0.5em;\n  font-weight: 700;\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  top: 2px;\n  -webkit-appearance: none;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  cursor: pointer;\n  margin-left: 8px;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  padding: 8px;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border-bottom: 1px solid ", ";\n  padding: 8px;\n  background-color: #efefef;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: ", ";\n  border: 1px solid ", ";\n  border-radius: 5px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: ", ";\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var ListWrapper = styled.div(_templateObject$8(), reset, function (props) {
  return props.theme.font.base;
});

var Handle$1 = function Handle(props) {
  return /*#__PURE__*/React.createElement("span", {
    "data-drag": true,
    style: {
      display: 'inline-block',
      width: '16px',
      cursor: 'move'
    }
  }, /*#__PURE__*/React.createElement("img", _extends({}, props, {
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItbW9yZS12ZXJ0aWNhbCI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMSI+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSI1IiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGN4PSIxMiIgY3k9IjE5IiByPSIxIj48L2NpcmNsZT48L3N2Zz4=",
    style: {
      position: 'relative',
      top: '3px',
      width: '16px'
    }
  })));
};

var IconDelete = function IconDelete() {
  return /*#__PURE__*/React.createElement("img", {
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItdHJhc2giPjxwb2x5bGluZSBwb2ludHM9IjMgNiA1IDYgMjEgNiI+PC9wb2x5bGluZT48cGF0aCBkPSJNMTkgNnYxNGEyIDIgMCAwIDEtMiAySDdhMiAyIDAgMCAxLTItMlY2bTMgMFY0YTIgMiAwIDAgMSAyLTJoNGEyIDIgMCAwIDEgMiAydjIiPjwvcGF0aD48L3N2Zz4=",
    style: {
      width: '16px'
    }
  });
};

var Item = styled.div(_templateObject2$5(), reset, function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.gray;
});
var TitleWrapper = styled.div(_templateObject3$2(), reset, function (props) {
  return props.theme.colors.gray;
});
var ContentWrapper = styled.div(_templateObject4$2(), reset);
var ListButton = styled.button(_templateObject5$1(), reset);
var Title = styled.span(_templateObject6$1(), reset);

var List = function List(_ref) {
  var defaultItems = _ref.items,
      listItem = _ref.listItem,
      template = _ref.template,
      primaryField = _ref.primaryField,
      onChangeList = _ref.onChangeList;

  var _React$useState = React.useState(defaultItems),
      items = _React$useState[0],
      setItems = _React$useState[1];

  var factory = function factory(template) {
    if (!template) throw new Error('Template not specified for this list');
    return Object.assign({}, template, {
      id: randomId()
    });
  };

  var handleChangeField = function handleChangeField(idx, field, value) {
    var newItems = updateFieldByIndex(items, field, value, idx);
    setItems(newItems);
    notifyChange(newItems);
  };

  var notifyChange = function notifyChange(items) {
    onChangeList('list', items);
  };

  var handleAdd = function handleAdd() {
    var newItems = add(items, factory(template));
    setItems(newItems);
    notifyChange(newItems);
  };

  var handleReorder = function handleReorder(items) {
    setItems(items);
    notifyChange(items);
  };

  var handleRemove = function handleRemove(idx) {
    if (!template && items.length === 1) return;
    var newItems = removeByIndex(items, idx);
    setItems(newItems);
    notifyChange(newItems);
  };

  return /*#__PURE__*/React.createElement(ListWrapper, null, !items && /*#__PURE__*/React.createElement("h4", null, "There are no items yet."), items && /*#__PURE__*/React.createElement(ReactSortable, {
    list: items,
    setList: handleReorder,
    handle: "[data-drag]",
    direction: "horizontal",
    dragoverBubble: true
  }, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.id,
      "data-id": idx
    }, /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Handle$1, null), /*#__PURE__*/React.createElement(Title, null, primaryField ? item[primaryField] : "Item " + (idx + 1))), (template || !template && items.length !== 1) && /*#__PURE__*/React.createElement(ListButton, {
      type: "button",
      danger: true,
      onClick: function onClick() {
        return handleRemove(idx);
      }
    }, /*#__PURE__*/React.createElement(IconDelete, null))), /*#__PURE__*/React.createElement(ContentWrapper, null, listItem(item, function (field, value) {
      return handleChangeField(idx, field, value);
    }, idx)));
  })), /*#__PURE__*/React.createElement(Button$1, {
    type: "button",
    variant: "success",
    onClick: handleAdd
  }, "Add item"));
};

List.defaultProps = {
  items: []
};

var containerClass = function containerClass(className, containerSettings) {
  var classes = [className];
  if (containerSettings && containerSettings.spacing !== 'none' && containerSettings.spacing !== undefined) classes.push("spacing-" + containerSettings.spacing);
  if (containerSettings && containerSettings.theme !== 'none' && containerSettings.theme !== undefined) classes.push(containerSettings.theme + "-bg");
  return classes.join(' ');
};

var Container = function Container(_ref) {
  var settings = _ref.settings,
      className = _ref.className,
      children = _ref.children;
  var props = {};
  props.className = containerClass(className, settings);
  if (settings && settings.sectionID) props.id = settings.sectionID;
  return /*#__PURE__*/React.createElement("div", props, children);
};

Container.defaultProps = {
  className: '',
  id: ''
};

var VimeoEmbed = function VimeoEmbed(_ref) {
  var videoId = _ref.videoId,
      autoplay = _ref.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    frameBorder: "0",
    allowFullScreen: "0",
    src: "https://player.vimeo.com/video/" + videoId + "?color=ffffff&title=0&byline=0&portrait=0&autoplay=" + (autoplay === true ? '1' : '0'),
    className: "content",
    allow: "autoplay"
  });
};

var YoukuEmbed = function YoukuEmbed(_ref2) {
  var videoId = _ref2.videoId,
      autoplay = _ref2.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    height: "0",
    width: "0",
    src: "https://player.youku.com/embed/" + videoId + "?autoplay=" + (autoplay === true ? '1' : '0'),
    frameBorder: "0",
    allowFullScreen: true,
    className: "content",
    allow: "autoplay"
  });
};

var YouTubeEmbed = function YouTubeEmbed(_ref3) {
  var videoId = _ref3.videoId,
      autoplay = _ref3.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    frameBorder: "0",
    allowFullScreen: "0",
    src: "https://youtube.com/embed/" + videoId + "?autoplay=" + (autoplay === true ? '1' : '0'),
    className: "content",
    allow: "autoplay"
  });
};

var videoType = function videoType(url) {
  if (url.includes('youtu')) return 'youtube';
  if (url.includes('vimeo')) return 'vimeo';
  if (url.includes('youku')) return 'youku';
};

var youtubeId = function youtubeId(url) {
  var matches = url.match(/(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/);
  return matches !== '' && matches !== null ? matches[5] : '';
};

var vimeoId = function vimeoId(url) {
  var matches = url.match(/http(s?):\/\/(www\.)?vimeo\.com\/(\d+)($|\/)/);
  return matches !== '' && matches !== null ? matches[3] : '';
};

var youkuId = function youkuId(url) {
  var matches = url.match(/http(s?):\/\/v\.youku\.com\/v_show\/id_([A-Za-z0-9=]+)\.html/);
  return matches !== '' && matches !== null ? matches[2] : '';
};

var videoId = function videoId(url) {
  if (videoType(url) === 'youtube') return youtubeId(url);
  if (videoType(url) === 'vimeo') return vimeoId(url);
  if (videoType(url) === 'youku') return youkuId(url);
};

var VideoComponentType = {
  youtube: YouTubeEmbed,
  vimeo: VimeoEmbed,
  youku: YoukuEmbed
};

var EmbeddedVideo = function EmbeddedVideo(_ref4) {
  var videoUrl = _ref4.videoUrl,
      _ref4$autoplay = _ref4.autoplay,
      autoplay = _ref4$autoplay === void 0 ? false : _ref4$autoplay;
  var vType = videoType(videoUrl);
  var vId = videoId(videoUrl);
  var VideoComponent = VideoComponentType[vType];

  if (VideoComponent) {
    return /*#__PURE__*/React.createElement(VideoComponent, {
      videoId: vId,
      autoplay: autoplay
    });
  }

  return null;
};

var MediaManager = /*#__PURE__*/function () {
  function MediaManager() {
    console.warn('MediaManager is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-image-input. ');
  }

  var _proto = MediaManager.prototype;

  _proto.findAll = function findAll(callback, params) {};

  _proto.uploadFile = function uploadFile(file, callback) {};

  _proto.update = function update(image, params, callback) {};

  _proto.destroy = function destroy(image, callback) {};

  return MediaManager;
}();

var ListInput = function ListInput(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(List, props));
};

var imgageSrc = function imgageSrc(src, variant) {
  if (_typeof(src) === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + variant);
  if (_typeof(src) === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return src.urls.original;
  if (_typeof(src) === 'object' && 'name' in src) return src.urls[variant];
  if (typeof src === 'string') return src;
  return null;
};

var Button = function Button(_ref) {
  var settings = _ref.settings,
      className = _ref.className;
  var button_id = settings.button_id,
      button_label = settings.button_label,
      button_link = settings.button_link,
      button_target = settings.button_target,
      button_type = settings.button_type,
      follow_link = settings.follow_link;
  var buttonClass;
  if (button_type === 'accented') buttonClass = 'btn-active-dark';
  if (button_type === 'regular') buttonClass = 'btn-passive-light';
  if (button_type === 'link') buttonClass = 'btn-text';
  if (className) buttonClass = buttonClass + " " + className;
  return /*#__PURE__*/React.createElement("a", {
    href: button_link,
    className: buttonClass,
    id: button_id,
    target: button_target,
    rel: follow_link === 'no-follow' ? 'nofollow' : ''
  }, button_label);
};

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  margin-bottom: 0;\n\n  & + div {\n    margin-top: ", ";\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: ", ";\n  font-size: ", ";\n  text-transform: uppercase;\n  font-weight: bold;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n\n  & > div {\n    width: 33.33%;\n    padding-right: ", ";\n\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n\n  &:last-child {\n    & > div {\n      margin-bottom: 0;\n    }\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  margin-right: ", ";\n  background-size: 100% auto;\n  background-repeat: none;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItc2xpZGVycyI+PGxpbmUgeDE9IjQiIHkxPSIyMSIgeDI9IjQiIHkyPSIxNCI+PC9saW5lPjxsaW5lIHgxPSI0IiB5MT0iMTAiIHgyPSI0IiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjIxIiB4Mj0iMTIiIHkyPSIxMiI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjgiIHgyPSIxMiIgeTI9IjMiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIyMSIgeDI9IjIwIiB5Mj0iMTYiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIxMiIgeDI9IjIwIiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxIiB5MT0iMTQiIHgyPSI3IiB5Mj0iMTQiPjwvbGluZT48bGluZSB4MT0iOSIgeTE9IjgiIHgyPSIxNSIgeTI9IjgiPjwvbGluZT48bGluZSB4MT0iMTciIHkxPSIxNiIgeDI9IjIzIiB5Mj0iMTYiPjwvbGluZT48L3N2Zz4=);\n\n}"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var SettingsIcon$1 = styled.span(_templateObject$9(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});
var ThreeColumns$1 = styled.div(_templateObject2$6(), reset, function (props) {
  return props.theme.font.base;
});
var FormSectionTitle$1 = styled.h6(_templateObject3$3(), reset, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.font.small;
});
var ButtonControl$1 = styled.div(_templateObject4$3(), reset, function (props) {
  return props.theme.font.base;
});

var mergeSettings$1 = function mergeSettings(settings, key, value) {
  var _Object$assign;

  return Object.assign({}, settings, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
};

var LinkSettings = function LinkSettings(_ref) {
  var label = _ref.label,
      value = _ref.value,
      _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(ButtonControl$1, null, /*#__PURE__*/React.createElement(FormSectionTitle$1, null, /*#__PURE__*/React.createElement(SettingsIcon$1, null), " ", label), /*#__PURE__*/React.createElement(ThreeColumns$1, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: value.label,
    onChange: function onChange(label) {
      return _onChange(mergeSettings$1(value, 'label', label));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Link",
    value: value.link,
    onChange: function onChange(link) {
      return _onChange(mergeSettings$1(value, 'link', link));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "ID",
    value: value.id,
    onChange: function onChange(id) {
      return _onChange(mergeSettings$1(value, 'id', id));
    }
  })), /*#__PURE__*/React.createElement(ThreeColumns$1, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "CSS Class",
    value: value.className,
    onChange: function onChange(className) {
      return _onChange(mergeSettings$1(value, 'className', className));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Target",
    options: [['_self', 'Self'], ['_blank', 'New Tab']],
    value: value.target,
    onChange: function onChange(target) {
      return _onChange(mergeSettings$1(value, 'target', target));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Follow Link",
    options: [['follow', 'Follow'], ['nofollow', 'No Follow']],
    value: value.rel,
    onChange: function onChange(rel) {
      return _onChange(mergeSettings$1(value, 'rel', rel));
    }
  })));
};

var DEFAULTS$1 = {
  label: 'link',
  link: '#',
  id: '',
  className: '',
  target: '_self',
  rel: 'follow'
};
LinkSettings.defaultProps = {
  label: 'Link  ',
  value: DEFAULTS$1
};
LinkSettings.defaults = DEFAULTS$1;

var Link = function Link(_ref) {
  var settings = _ref.settings,
      children = _ref.children,
      className = _ref.className;
  var id = settings.id,
      label = settings.label,
      link = settings.link,
      target = settings.target,
      rel = settings.rel;
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    className: [settings.className, className].join(' '),
    id: id || '',
    target: target,
    rel: rel
  }, children || label);
};

var RaketaUIProvider = function RaketaUIProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children);
};

RaketaUIProvider.defaultProps = {
  theme: theme
};
export { Button, ButtonSettings, Container, Dialog, EmbeddedVideo, ImageInput, ImagePicker, Img, Link, LinkSettings, List, ListInput, MediaManager, PageBuilder, RaketaUIProvider, RichText, SelectMenu, TextArea, TextInput, imgageSrc as imageSrc };